// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { IconQuestionMark } from '@tabler/icons';
import { CustomAttributeDTO } from '../../../Types/CustomAttributeT';

const LabelWithDescription: FC<{ attribute: CustomAttributeDTO }> = ({ attribute }) => {
  const { name, description } = attribute;
  return (
    <Group spacing={5}>
      <Text size={14} sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'white' : theme.colors.gray[9] })}>
        {name}
      </Text>
      {description && (
        <Tooltip multiline withArrow position="bottom" label={description} width={200} transition="slide-down">
          <ThemeIcon
            size={14}
            sx={(theme) => ({
              borderRadius: '50%',
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.silver[4] : theme.colors.gray[3],
            })}
          >
            <IconQuestionMark size={12} />
          </ThemeIcon>
        </Tooltip>
      )}
    </Group>
  );
};

export default LabelWithDescription;
